import React, { useState, useEffect, useRef } from 'react';
import Helmet from 'react-helmet';
import { CSSTransition } from 'react-transition-group';
import throttle from 'lodash.throttle';
import { addLoopedFocus } from '../../../../util/accessibility';
 
import SafetyList from '../SafetyList';
 
import * as s from './styles';
import * as ps from '../styles';
//Icon
import icon_plus_small from '../../../../assets/icon-colors/mutibrand-icons/icon-plus-grey.svg';
import icon_plus_small_blue from '../../../../assets/icon-colors/mutibrand-icons/icon-plus-blue.svg';
import icon_plus_small_green from '../../../../assets/icon-colors/mutibrand-icons/icon-plus-green.svg';
 
import IndicationCopy from '../copy/safety-panel/indication';
import {safetyWeliregCopy ,safetyKeytrudaQlexCopy} from '../copy/safety-panel/safety';
import useWindowSize from '../../../../util/hooks/useWindowSize';
import { validateStringOrFunction } from '../../../../util/general';
 
const HASH_TRIGGER = '#ssi-safety';
 
 
const MultiBrandIndicationAndSafetyDrawer = ({ location, pageKey }) => {
  const safetyRef = useRef(null);
  const safetyRefSecond = useRef(null);
  const indicationRef = useRef(null);
  const {width} = useWindowSize()
 
  const [safetyDrawerOpen, setSafetyDrawerOpen] = useState(false);
  const [safetyDrawerOpenSecond, setSafetyDrawerOpenSecond] = useState(false);
  const [indicationDrawerOpen, setIndicationDrawerOpen] = useState(false);
  const [showSsiJobCode, setShowSsiJobCode] = useState(false);
 
  const [safetyPosition, setSafetyPosition] = useState(0);
  const [scrolledPast, setScrolledPast] = useState(false);
  const [overrideCcpaStyle, setOverrideCcpaStyle] = useState(false);
  const [isCollapsedFirst, setIsCollapsedFirst] = useState(false);
   const blueRef = useRef(null);
const greenRef = useRef(null);
 
  // Check hash on load
  //----
  useEffect(() => {
    if (location.hash.includes(HASH_TRIGGER)) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      setShowSsiJobCode(true);
      openSafety();
    }
  }, [location]);
 
  const hideCcpaBannerIfPresent = () => {
    const ccpaBanner = document.querySelector('#onetrust-banner-sdk');
    if (ccpaBanner){
      ccpaBanner.style.zIndex = '-1';
      setOverrideCcpaStyle(true);
    }
  };
 
  const showCcpaBanner = () => {
    const ccpaBanner = document.querySelector('#onetrust-banner-sdk');
    if (ccpaBanner && overrideCcpaStyle){
      ccpaBanner.style.zIndex = '2147483645';
      setOverrideCcpaStyle(false);
    }
  };
 
 
  // Drawer Toggle Controls
  //----
  const openIndications = () => {
    hideCcpaBannerIfPresent();
    setIndicationDrawerOpen(true);
    document.body.classList.add("no-scroll");
    if (indicationRef.current) {
      addLoopedFocus(indicationRef.current);
    }
  };
 
  const openSafety = () => {
    hideCcpaBannerIfPresent();
    setSafetyDrawerOpen(true);
    document.body.classList.add("no-scroll");
    if (safetyRef.current) {
      addLoopedFocus(safetyRef.current);
    }
  };
  const openSafetySecond = () => {
    hideCcpaBannerIfPresent();
    setSafetyDrawerOpenSecond(true);
    document.body.classList.add("no-scroll");
    if (safetyRefSecond.current) {
      addLoopedFocus(safetyRefSecond.current);
    }
  };
 
  const closeDrawers = () => {
    setSafetyDrawerOpen(false);
    setIndicationDrawerOpen(false);
    setSafetyDrawerOpenSecond(false);
    document.body.classList.remove("no-scroll");
    showCcpaBanner();
    if (showSsiJobCode) {
      setShowSsiJobCode(false);
    }
  };
 
 
  // Scroll Watch
  //----
  const saveSafetyPosition = () => {
    const safetyCopyEl = document.querySelector('#safety-scroll-target');
    if (safetyCopyEl) {
      setSafetyPosition(safetyCopyEl.offsetTop);
    }
  };
 
  const safetyScrollWatch = () => {
    if(window.scrollY > 2){
      setIsCollapsedFirst(true);
    }
    const currentPageBottomPosition = window.scrollY + window.innerHeight - 80;
    setScrolledPast(currentPageBottomPosition > safetyPosition);
  };
  const throttledSafetyScrollWatch = throttle(safetyScrollWatch, 600);
 
  const handleKeyUp = (event) => {
    if (event.key === 'Escape' || event.keyCode === 27) {
      closeDrawers();
    }
  };
 
  useEffect(() => {
    saveSafetyPosition();
    
    if (safetyPosition) {
      window.addEventListener('scroll', throttledSafetyScrollWatch);
 
      return () => {
        window.removeEventListener('scroll', throttledSafetyScrollWatch);
      };
    }
  }, [safetyPosition]);
 
  useEffect(() => {
      document.addEventListener('keyup', handleKeyUp);
      window.addEventListener('resize', () => {
        if (safetyDrawerOpen || indicationDrawerOpen || safetyDrawerOpenSecond){
          hideCcpaBannerIfPresent();
        }
      });
 
      return () => {
        document.removeEventListener('keyup', handleKeyUp);
        window.removeEventListener('resize', () => {
          if (safetyDrawerOpen || indicationDrawerOpen || safetyDrawerOpenSecond){
            hideCcpaBannerIfPresent();
          }
        });
      };
  }, [safetyDrawerOpen, indicationDrawerOpen, safetyDrawerOpenSecond]);



  //----
 
 
  return (
    <>
      {(indicationDrawerOpen || safetyDrawerOpen || safetyDrawerOpenSecond) &&
        <Helmet>
          <html lang="en-us" className="no-scroll" />
        </Helmet>
      }
 
      <s.MultiBrandLaunchButtonContainer isCollapsed={scrolledPast}>
 
        <s.MultiBrandIndicationsLaunchButton isCollapsedFirst={isCollapsedFirst} onClick={openIndications}>
          <header>
                <s.MultiBrandPreviewTitle>{ validateStringOrFunction(IndicationCopy[pageKey]?.buttonTitle || IndicationCopy.mt.buttonTitle) }</s.MultiBrandPreviewTitle>
                <button aria-label={`More information about ${validateStringOrFunction(IndicationCopy[pageKey]?.buttonTitle || IndicationCopy.mt.buttonTitle)}`} aria-expanded={indicationDrawerOpen}>
                    <img src={icon_plus_small} alt={' '} />
                </button>
          </header>
          <div>
            <s.MultiBrandPreviewText > {validateStringOrFunction(
    IndicationCopy[pageKey]?.indicationBody || IndicationCopy.indicationBody
  )}</s.MultiBrandPreviewText>
          </div>
        </s.MultiBrandIndicationsLaunchButton>
 
        <CSSTransition
          in={indicationDrawerOpen}
          timeout={400}
          classNames="information-drawer"
        >
          <s.MultiBrandInformationDrawer
            isOpen={indicationDrawerOpen}
            drawerName="indications"
            ref={indicationRef}
          >
            <s.MultiBrandDrawerHeader>
              
              <s.MultiBrandModalButtonWrapper>
                <s.MultiBrandCloseButton
                  onClick={closeDrawers}
                  type="button"
                  aria-label="close"
                >CLOSE</s.MultiBrandCloseButton>
              </s.MultiBrandModalButtonWrapper>
            </s.MultiBrandDrawerHeader>
 
            <div className="container custom-key">
              <ps.MultiBrandHeadingHThree>
                { validateStringOrFunction(IndicationCopy[pageKey]?.indicationexpandTitle || IndicationCopy.mt.indicationexpandTitle) }
              </ps.MultiBrandHeadingHThree>
              <ps.MultiBrandIsiBody>
                <p> {validateStringOrFunction(
    IndicationCopy[pageKey]?.indicationBody || IndicationCopy.indicationBody
  )}</p>
              </ps.MultiBrandIsiBody>

              {
                IndicationCopy[pageKey] ? <>
                <ps.MultiBrandHeadingHThree>
                { validateStringOrFunction(IndicationCopy[pageKey].expandTitle) }
              </ps.MultiBrandHeadingHThree>
              <ps.MultiBrandIsiBody>
                <div>{ validateStringOrFunction(IndicationCopy[pageKey].body) }</div>
              </ps.MultiBrandIsiBody>
                </> : null
              }
            </div>
 
          </s.MultiBrandInformationDrawer>
        </CSSTransition>
 
       {
          width <= 992 ?
          <MobileIndicationDrawer safetyDrawerOpen={safetyDrawerOpen} openSafety={openSafety} closeDrawers={closeDrawers} safetyRef={safetyRef} showSsiJobCode={showSsiJobCode} safetyDrawerOpenSecond={safetyDrawerOpenSecond} safetyRefSecond={safetyRefSecond} openSafetySecond={openSafetySecond}  pageKey={pageKey}  /> :
          <DesktopIndicationDrawer safetyDrawerOpen={safetyDrawerOpen} openSafety={openSafety} closeDrawers={closeDrawers} safetyRef={safetyRef} showSsiJobCode={showSsiJobCode}  pageKey={pageKey} />

       }
 
      </s.MultiBrandLaunchButtonContainer>

      <s.MultiBrandDrawerOverlay
        isActive={safetyDrawerOpen || indicationDrawerOpen}
        onClick={closeDrawers}
      />
    </>
  );
};

const DesktopIndicationDrawer = ({safetyDrawerOpen, closeDrawers, safetyRef, showSsiJobCode, openSafety,pageKey}) =>{
  
    const safetyWelireg = safetyWeliregCopy[pageKey] || safetyWeliregCopy.mt;
    
  return (
      <>
         <s.MultiBrandSafetyLaunchButton onClick={openSafety}>
          
          <s.MultiBrandTwoCol>
            <div className='blue-container'>
              <s.MultiBrandPreviewTitle><span className='blue-highlight'>{validateStringOrFunction(safetyWelireg.title)}</span></s.MultiBrandPreviewTitle>
            <ps.MultiBrandSafetyWarningTitle flat>
              { validateStringOrFunction(safetyWelireg.warningList.title) }
            </ps.MultiBrandSafetyWarningTitle>
 
            <ps.MultiBrandSafetyWarningList flat>
              {safetyWelireg.warningList.items.map((item, i) => (
                <li key={i}>{ validateStringOrFunction(item) }</li>
              ))}
            </ps.MultiBrandSafetyWarningList>
            </div>
            <div className='green-container'>
              <header>
            {/* <s.MultiBrandPreviewTitle dangerouslySetInnerHTML={{ __html: SafetyCopy.title }} /> */}
            <s.MultiBrandPreviewTitle>{validateStringOrFunction(safetyKeytrudaQlexCopy.title)}</s.MultiBrandPreviewTitle>

                <button aria-label={`More information about ${validateStringOrFunction(safetyKeytrudaQlexCopy.title)}`} aria-expanded={safetyDrawerOpen}>
                    <img  src={icon_plus_small} alt={' '} />
                </button>
          </header>
            {safetyKeytrudaQlexCopy.warningList ? <><ps.MultiBrandSafetyWarningTitle flat>
              { validateStringOrFunction(safetyKeytrudaQlexCopy.warningList.title) }
            </ps.MultiBrandSafetyWarningTitle>
 
            <ps.MultiBrandSafetyWarningList flat>
              {safetyKeytrudaQlexCopy.warningList.items.map((item, i) => (
                <li key={i}>{ validateStringOrFunction(item) }</li>
              ))}
            </ps.MultiBrandSafetyWarningList></> : <><ps.MultiBrandSafetyItemTitle flat>
              { validateStringOrFunction(safetyKeytrudaQlexCopy.previewText.title) }
            </ps.MultiBrandSafetyItemTitle>
 
            <ps.MultiBrandSafetyItemList flat>
              {safetyKeytrudaQlexCopy.previewText.items.map((item, i) => (
                <li key={i}>{ validateStringOrFunction(item) }</li>
              ))}
            </ps.MultiBrandSafetyItemList></>
          }
            </div>
          </s.MultiBrandTwoCol>
          
        </s.MultiBrandSafetyLaunchButton>
      <CSSTransition
          in={safetyDrawerOpen}
          timeout={400}
          classNames="information-drawer"
        >
          <s.MultiBrandInformationDrawer
            isOpen={safetyDrawerOpen}
            drawerName="safety"
            ref={safetyRef}
          >
            <s.MultiBrandDrawerHeader drawerName="safety">
             
              <s.MultiBrandModalButtonWrapper>
                <s.MultiBrandCloseButton
                  onClick={closeDrawers}
                  type="button"
                  aria-label="close"
                >CLOSE</s.MultiBrandCloseButton>
              </s.MultiBrandModalButtonWrapper>
            </s.MultiBrandDrawerHeader>
 
            <div className="container">
              
              <ps.MultiBrandTwoIndicationSection className='expand-container'>
                  <div className='blue-container'>
                    <ps.MultiBrandHeadingHThree><span className='blue-highlight'>{validateStringOrFunction(safetyWelireg.expandTitle)}</span></ps.MultiBrandHeadingHThree>
                      <SafetyList showSsiJobCode={showSsiJobCode} dataList={safetyWelireg} />
                  </div>
                  <div className='green-container'>
                    <ps.MultiBrandHeadingHThree>{validateStringOrFunction(safetyKeytrudaQlexCopy.expandTitle)}</ps.MultiBrandHeadingHThree>
                      <SafetyList showSsiJobCode={showSsiJobCode} dataList={safetyKeytrudaQlexCopy} />
                  </div>
              </ps.MultiBrandTwoIndicationSection>
            </div>
          </s.MultiBrandInformationDrawer>
        </CSSTransition>
      </>

    )
}
const MobileIndicationDrawer = ({safetyDrawerOpen, closeDrawers,openSafety, safetyRef, showSsiJobCode, safetyDrawerOpenSecond, safetyRefSecond, openSafetySecond,pageKey}) =>{
    const safetyWelireg = safetyWeliregCopy[pageKey] || safetyWeliregCopy.mt;
    const blueRef = useRef(null);   
    const greenRef = useRef(null);
    const headerRef = useRef(null);
    
    useEffect(() => {
    const observer = new ResizeObserver(() => {
        if (blueRef.current) {
            document.documentElement.style.setProperty(
                "--blue-height",
                `${blueRef.current.offsetHeight}px`
            );
        }

        if (greenRef.current) {
            document.documentElement.style.setProperty(
                "--green-height",
                `${greenRef.current.offsetHeight}px`
            );
        }
        if (headerRef.current) {
            document.documentElement.style.setProperty(
                "--header-height",
                `${headerRef.current.offsetHeight}px`
            );
        }
    });

    if (blueRef.current) observer.observe(blueRef.current);
    if (greenRef.current) observer.observe(greenRef.current);
    if (headerRef.current) observer.observe(headerRef.current);

    return () => observer.disconnect();
}, []);
  return (
      <>
      
      <s.MultiBrandSafetyLaunchButton  ref={blueRef} onClick={openSafety} className='safetywrapper'>
          <header>
            {/* <s.MultiBrandPreviewTitle dangerouslySetInnerHTML={{ __html: SafetyCopy.title }} /> */}
            <s.MultiBrandPreviewTitle><span className='blue-highlight'>{validateStringOrFunction(safetyWelireg.title)}</span></s.MultiBrandPreviewTitle>
                <button aria-label={`More information about ${validateStringOrFunction(safetyWelireg.title)}`} aria-expanded={safetyDrawerOpen}>
                    <img  src={icon_plus_small_blue} alt={' '} />
                </button>
          </header>
          <div className='blue-container'>
            <ps.MultiBrandSafetyWarningTitle flat ref={headerRef}>
              { validateStringOrFunction(safetyWelireg.warningList.title) }
            </ps.MultiBrandSafetyWarningTitle>
 
            <ps.MultiBrandSafetyWarningList flat>
              {safetyWelireg.warningList.items.map((item, i) => (
                <li key={i}>{ validateStringOrFunction(item) }</li>
              ))}
            </ps.MultiBrandSafetyWarningList>
          </div>
        </s.MultiBrandSafetyLaunchButton>   
      <CSSTransition
          in={safetyDrawerOpen}
          timeout={400}
          classNames="information-drawer"
        >
          <s.MultiBrandInformationDrawer
            isOpen={safetyDrawerOpen}
            drawerName="safety"
            ref={safetyRef}
          >
            <s.MultiBrandDrawerHeader drawerName="safety">
             
              <s.MultiBrandModalButtonWrapper>
                <s.MultiBrandCloseButton
                  onClick={closeDrawers}
                  type="button"
                  aria-label="close"
                >CLOSE</s.MultiBrandCloseButton>
              </s.MultiBrandModalButtonWrapper>
            </s.MultiBrandDrawerHeader>
 
            <div className="container custom-welireg">
              <ps.MultiBrandHeadingHThree><span>{validateStringOrFunction(safetyWelireg.expandTitle)}</span></ps.MultiBrandHeadingHThree>
              <SafetyList showSsiJobCode={showSsiJobCode} dataList={safetyWelireg} className='blue-container'/>
            </div>
          </s.MultiBrandInformationDrawer>
        </CSSTransition>

      <s.MultiBrandSafetyLaunchButton ref={greenRef} onClick={openSafetySecond}>
          <header>
            {/* <s.MultiBrandPreviewTitle dangerouslySetInnerHTML={{ __html: SafetyCopy.title }} /> */}
            <s.MultiBrandPreviewTitle>{validateStringOrFunction(safetyKeytrudaQlexCopy.title)}</s.MultiBrandPreviewTitle>
                <button aria-label={`More information about ${validateStringOrFunction(safetyKeytrudaQlexCopy.title)}`} aria-expanded={safetyDrawerOpenSecond}>
                    <img  src={icon_plus_small_green} alt={' '} />
                </button>
          </header>
          <div className='green-container' >
            {
              safetyKeytrudaQlexCopy.warningList ?<>
            <ps.MultiBrandSafetyWarningTitle flat ref={headerRef}>
              { validateStringOrFunction(safetyKeytrudaQlexCopy.warningList.title) }
            </ps.MultiBrandSafetyWarningTitle>
 
            <ps.MultiBrandSafetyWarningList flat>
              {safetyKeytrudaQlexCopy.warningList.items.map((item, i) => (
                <li key={i}>{ validateStringOrFunction(item) }</li>
              ))}
            </ps.MultiBrandSafetyWarningList>
           </>: <><ps.MultiBrandSafetyItemTitle flat>
              { validateStringOrFunction(safetyKeytrudaQlexCopy.previewText.title) }
            </ps.MultiBrandSafetyItemTitle>
 
            <ps.MultiBrandSafetyItemList flat>
              {safetyKeytrudaQlexCopy.previewText.items.map((item, i) => (
                <li key={i}>{ validateStringOrFunction(item) }</li>
              ))}
            </ps.MultiBrandSafetyItemList></>
            }
            </div>
        </s.MultiBrandSafetyLaunchButton>
      <CSSTransition
          in={safetyDrawerOpenSecond}
          timeout={400}
          classNames="information-drawer"
        >
          <s.MultiBrandInformationDrawer
            isOpen={safetyDrawerOpenSecond}
            drawerName="safety"
            ref={safetyRefSecond}
          >
            <s.MultiBrandDrawerHeader drawerName="safety">
             
              <s.MultiBrandModalButtonWrapper>
                <s.MultiBrandCloseButton
                  onClick={closeDrawers}
                  type="button"
                  aria-label="close"
                >CLOSE</s.MultiBrandCloseButton>
              </s.MultiBrandModalButtonWrapper>
            </s.MultiBrandDrawerHeader>
 
            <div className="container custom-qlex">
              <ps.MultiBrandHeadingHThree>{validateStringOrFunction(safetyKeytrudaQlexCopy.expandTitle)}</ps.MultiBrandHeadingHThree>
              <SafetyList showSsiJobCode={showSsiJobCode} dataList={safetyKeytrudaQlexCopy} className='green-container'/>
            </div>
          </s.MultiBrandInformationDrawer>
        </CSSTransition>
      </>

    )
}
 
 
export default MultiBrandIndicationAndSafetyDrawer;
 